<template>
  <section class="top-chat-msg" v-if="chatMsgRecommend?.msg_id">
    <div class="top-chat-msg-content">
      <span class="tag-text">{{ $t('host.k_512001') }}</span>
      <span>
        {{
          chatMsgRecommend.msg_account_role_type == 2
            ? chatMsgRecommend.msg_account_nickname
            : roleMap[chatMsgRecommend.msg_account_role_type] + ':'
        }}
      </span>
      <span v-html="chatMsgRecommend.msg_content"></span>
    </div>
    <vh-button class="tag-text" type="text" @click="cancelRecommend" v-if="roleName != 2">
      {{ $t('host.k_512002') }}
    </vh-button>
    <i v-else class="vh-iconfont vh-line-close" @click="closeRecommend"></i>
  </section>
</template>
<script>
  import { useChatServer } from 'middle-domain';
  export default {
    data() {
      return {
        roleMap: {
          1: this.$t('host.k_616014'),
          3: this.$t('host.k_616015'),
          4: this.$t('host.k_616016')
        }
      };
    },
    computed: {
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      chatMsgRecommend() {
        const msg = { ...this.$domainStore.state.chatServer.chatMsgRecommend };
        if (msg?.msg_account_role_type == 2) {
          msg.msg_account_nickname =
            this.$domainStore.state.roomBaseServer.configList['chat_nickname_encryption'] == 1 &&
            this.roleName == 2
              ? msg?.msg_account_nickname.substring(0, 1) + '**'
              : msg.msg_account_nickname.substring(0, 11);
          if (msg.msg_account_nickname) {
            msg.msg_account_nickname = msg.msg_account_nickname + ':';
          }
        }

        return msg;
      }
    },
    methods: {
      cancelRecommend() {
        useChatServer()
          .handleRecommendMsg({
            webinar_id: this.$domainStore.state.roomBaseServer.watchInitData.webinar.id,
            msg_id: this.chatMsgRecommend.msg_id,
            recommend_status: 0
          })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage.success(this.$t('host.k_512003'));
            }
          });
      },
      closeRecommend() {
        this.$domainStore.state.chatServer.chatMsgRecommend = null;
      }
    }
  };
</script>
<style lang="less" scoped>
  .top-chat-msg {
    background: var(--theme-notice-column-bg);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 10px;
    line-height: 24px;
    font-size: 14px;
    display: flex;
    z-index: 10;
    &-content {
      flex: 1;
      color: var(--theme-notice-column-text);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 48px;
      img {
        height: 40px !important;
        width: 40px !important;
      }
    }
    .tag-text {
      color: var(--theme-notice-tag-text);
    }
    .vh-line-close {
      color: var(--theme-notice-column-text);
      cursor: pointer;
    }
  }
</style>
